import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-bar">
      <div className="footer-content">
        <p>&copy;2025 Dockyard Total Solution (Pvt) Ltd. All rights reserved.</p>
        <p>
          Contact us:{" "}
          <a href="mailto:dockyard@totalsolution.com">
          dockyard@totalsolution.com
          </a>
        </p>
        <p>Address: No. 233, Jayantha Mallawarachchi Mawatha, Colombo 14.</p>
      </div>
    </footer>
  );
};

export default Footer;
